import { dateConvertTimezone } from "src/app/platform/utils/functions";

export class InvoicesData {
    id: number;
    type: string;
    typeShort: string;
    total: number;
    balance: number;
    periode: number;
    status: string;
    date: string;
    dateExpiration: string;
    receipt: string;
    isCalls: boolean;
    pdfURL: string;
    pdfURLShort: string;

    constructor() {
        this.id = 0;
        this.type = '';
        this.typeShort = '';
        this.total = 0;
        this.balance = 0;
        this.periode = 0;
        this.status = '';
        this.date = '';
        this.dateExpiration = '';
        this.receipt = '';
        this.isCalls = false;
        this.pdfURL = '';
        this.pdfURLShort = '';
    }

    configData(parameters: any): InvoicesData {
        this.id = parameters.id;
        this.type = this.setTypeData(parameters.tipo);
        this.typeShort = parameters.tipoAbreviado;
        this.total = parameters.total;
        this.balance = parameters.saldo;
        this.periode = parameters.periodo;
        this.status = parameters.estado;
        this.date = dateConvertTimezone(new Date(parameters.fechaEmision), 'Etc/Greenwich');
        this.dateExpiration = dateConvertTimezone(new Date(parameters.fechaVencimiento), 'Etc/Greenwich');
        this.receipt = parameters.comprobante;
        this.isCalls = parameters.llamadas;
        this.pdfURL = parameters.pdfUri;
        this.pdfURLShort = parameters.pdfUriShort;

        return this;
    }

    setTypeData(type: string): string {
        return type;

        if (type === 'Factura'){
            return 'Factura';
        } else if (type === 'Nota de credito') {
            return 'Credito';
        } else if (type === 'Nota de debito') {
            return 'Debito';
        }

        return '';
    }

    isPayable(): boolean {
        if (this.status === 'Impaga' || this.status === 'Pendiente') {
            return true;
        }

        return false;
    }
}

export class InvoicesCallsData {
    type: string;
    date: string;
    amount: number;
    total: number;
    destination: string;
    destinationNumber: string;
    originNumber: string;
    minutes: number;
    cpp: number;

    constructor() {
        this.type = '';
        this.date = '';
        this.amount = 0;
        this.total = 0;
        this.destination = '';
        this.destinationNumber = '';
        this.originNumber = '';
        this.minutes = 0;
        this.cpp = 0;
    }

    configData(parameters: any): InvoicesCallsData {
        this.type =  this.setTypeData(parameters.tipo);
        this.date = parameters.fecha;
        this.amount = parameters.importe;
        this.total = parameters.total;
        this.destination = parameters.destino;
        this.destinationNumber = parameters.numDestino;
        this.originNumber = parameters.numOrigen;
        this.minutes = parameters.minutos;
        this.cpp = parameters.cpp;

        return this;
    }

    setTypeData(type: string): string {
        if (type === 'LOC'){
            return 'Llamada local';
        }

        return type;
    }
}
